export const NAME = 'name';
export const IS_AUTO_SYNC = 'autoSync';
export const OWNER = 'owner';
export const DATA_TYPE = 'dataType';
export const CREDENTIALS = 'credentials';
export const ACCOUNT = 'account';
export const INCLUDE_DEPOSIT_VALUES = 'includeDepositValues';

export const DESCRIPTION = 'description';
export const TYPE = 'type';

export const MULTIPLY_DEPOSIT_AMOUNTS = 'powerMultiply';
export const PARENT_AUDIENCE = 'parentAudience';
export const PARTNER = 'partner';
export const PARTNER_AUDIENCES = 'partnerAudiences';
export const PARTNER_DATA = 'partnerData';

export const PARTNER_API_ID = 'partnerApiId';
